import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/nik4o/Desktop/New Ver Web/iliqta/app/components/TestingB.tsx");
;
import(/* webpackMode: "eager" */ "/Users/nik4o/Desktop/New Ver Web/iliqta/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
